import { InputRow, SelectRow, SwitchRow, DateRow } from "../Rows";
import { FormCard, FormGrid } from "../FormCard";
import { useTranslation } from "react-i18next";

const DiscountForm = ({
  discount,
  handleInputChange,
  invalidFields,
  setInvalidFields,
  title,
}) => {
  const { t } = useTranslation();
  const discountTypeOptions = ["Fixed", "Percentage"].map((item) => ({
    value: item,
    label: t(`partner.priceValueType.${item}`),
  }));

  const pricingModelOptions = ["Volume", "Flat"].map((item) => ({
    value: item,
    label: t(`discount.conditionType.${item}`),
  }));

  return (
    <FormCard title={title || t("discount.details")}>
      <FormGrid>
        <InputRow
          label={t("common.name")}
          value={discount?.name || ""}
          onChange={(value) => handleInputChange("name", value)}
          invalid={invalidFields?.includes("name")}
          required
        />

        <InputRow
          label={t("common.description")}
          value={discount?.description || ""}
          onChange={(value) => handleInputChange("description", value)}
        />

        <SelectRow
          label={t("common.type")}
          value={discount?.discountValueType || ""}
          options={discountTypeOptions}
          onChange={(value) => handleInputChange("discountValueType", value)}
          invalid={invalidFields?.includes("discountValueType")}
          required
        />

        <SelectRow
          label={t("discount.condition")}
          value={discount?.discountConditionType || ""}
          options={pricingModelOptions}
          onChange={(value) => handleInputChange("discountConditionType", value)}
          invalid={invalidFields?.includes("discountConditionType")}
          required
        />

        <SwitchRow
          label={t("discount.calculatedPerSite")}
          checked={!!discount?.isCalculatedPerChargingSite}
          onChange={(checked) => {
            handleInputChange("isCalculatedPerChargingSite", !!checked);
          }}
        />

        <InputRow
          label={t("discount.minKwh")}
          isNumber
          value={discount?.minKwh ?? ""}
          onChange={(value) => handleInputChange("minKwh", value)}
        />

        <InputRow
          label={t("discount.maxKwh")}
          isNumber
          value={discount?.maxKwh ?? ""}
          onChange={(value) => handleInputChange("maxKwh", value)}
        />

        <InputRow
          label={
            discount?.discountValueType === "Fixed"
              ? t("discount.discountedAmountKr")
              : t("discount.discountedAmountPct")
          }
          isNumber
          value={discount?.discountValue ?? ""}
          onChange={(value) => handleInputChange("discountValue", value)}
        />

        <DateRow
          label={t("discount.fromDateTime")}
          value={discount?.startDateTimeUtc || ""}
          onChange={(value) => {
            handleInputChange("startDateTimeUtc", value);
            if (typeof setInvalidFields === "function") {
              setInvalidFields((prev) =>
                (prev || []).filter((field) => field !== "startDateTimeUtc")
              );
            }
          }}
        />

        <DateRow
          label={t("discount.toDateTimeOptional")}
          value={discount?.endDateTimeUtc || ""}
          onChange={(value) => handleInputChange("endDateTimeUtc", value)}
        />
      </FormGrid>

      {invalidFields?.includes("startDateTimeUtc") && (
        <p className="mt-4 text-xs text-error-400">{t("discount.fromDateRequired")}</p>
      )}
    </FormCard>
  );
};

export default DiscountForm;
